import territoryFeedbackLogin from "@/services/territory-feedback/territoryFeedbackLogin";
import TerritoryFeedbackService from "@/services/territory-feedback/territoryFeedbackService";
import AccountsTableDetailsRecord from "@/services/territory-feedback/model/accountsTableDetailsRecord";
import FeedbackLocalDataService from "@/services/territory-feedback/feedbackLocalDataService";
import { AlignError } from "@/services/territory-feedback/utils/territoryFeedbackErrors";

class TerritoryFeedbackClient {
  constructor(alignURL, sfEndpoint, sfSession, userId, terrId) {
    this._sfEndpoint = sfEndpoint;
    this._sfSession = sfSession;
    this._userId = userId;
    this._terrId = terrId;
    this.territoryFeedbackService = new TerritoryFeedbackService(alignURL);
    this.feedbackLocalDataService = null;
  }

  initFeedbackData(userId, terrId) {
    return async (resolve, reject) => {
      try {
        await territoryFeedbackLogin.territoryFeedbackLogin(userId);
        this.accountsTableDetail = new AccountsTableDetailsRecord(
          await this.territoryFeedbackService.getTerritoryModelDetails(terrId, {
            headers: {
              "SF-Endpoint": this._sfEndpoint,
              "SF-Session": this._sfSession
            }
          })
        );
        resolve(new FeedbackLocalDataService(this.accountsTableDetail));
      } catch (serviceError) {
        reject(new AlignError(serviceError));
      }
    };
  }

  setUpFeedbackLocalDataService() {
    if (this.feedbackLocalDataService == null) {
      this.feedbackLocalDataService = new Promise(
        this.initFeedbackData(this._userId, this._terrId)
      );
    }
  }

  getFeedbackMetadata() {
    this.setUpFeedbackLocalDataService();
    return this.feedbackLocalDataService.then(resp => {
      return {
        terrMetadata: resp.territoryModelMetadata.metadata,
        success: true
      };
    });
  }

  getFeedbackData() {
    this.setUpFeedbackLocalDataService();
    return this.feedbackLocalDataService.then(resp => {
      return {
        terrData: resp.territoryModelDetails,
        success: true
      };
    });
  }

  updateTerritoryId(userId, testRecordId) {
    if (userId !== this._userId) {
      this._userId = userId;
    }
    if (testRecordId !== this._terrId) {
      this._terrId = testRecordId;
    }
    this.feedbackLocalDataService = new Promise(
      this.initFeedbackData(this._userId, this._terrId)
    );
  }
}

export default TerritoryFeedbackClient;

